export const PUBLIC_ROUTES = ['/', '/sign-in'];
